export default __webpack_public_path__ + "static/VehicleSearchAgent-cb8b6c74fb622b58d60ca9b7e0a4a9ac.jpg";